import SYSApi from './_sysApi';
import httpClient from '@/apis/base/httpclient';

class SYSAuditingLogAPI extends SYSApi {
  constructor() {
    super();
  }
  controllerName = 'SYSAccessHistorys';

  /**
   * Xóa lịch sử đến ngày X
   * @param {*} payload  đến ngày
   * @returns
   * TTLONG 24/11/2022
   */
  async deleteHistory(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/DeleteHistory?toDate=' + payload,
    };

    return await httpClient.deleteAsync(request);
  }

  /**
   * Lấy dữ liệu nhật ký xuất Excel
   * @param {*} payload
   * @returns
   * TTLONG 25/11/2022
   */
  async accessHistoryExcel(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + `/AccessHistoryExcel?fromDate=${payload.fromDate}&toDate=${payload.toDate}&sort=${payload.sort}`,
    };

    return await httpClient.getAsync(request);
  }
}

export default new SYSAuditingLogAPI();
